import { crosswordStyles, gridContainer } from "./CrosswordPuzzle.styles";

interface CrosswordGridProps {
  grid: string[][];
  positionToNumber: Map<string, number>;
  hintLetters: Record<string, string>;
  studentAnswers: Record<string, string>;
  isStudent: boolean;
  onCellChange: (x: number, y: number, value: string) => void;
}

const CrosswordGrid = ({
  grid,
  positionToNumber,
  hintLetters,
  studentAnswers,
  isStudent,
  onCellChange,
}: CrosswordGridProps) => {
  const gridHeight = grid.length;
  const gridWidth = grid[0]?.length ?? 0;

  if (gridHeight === 0 || gridWidth === 0) return null;

  const {
    crosswordGrid,
    emptyCellBase,
    gridCellBase,
    getCellNumber,
    getCellInput,
    getCellHint,
  } = crosswordStyles({ gridWidth, gridHeight });

  return (
    <div css={gridContainer}>
      <div css={crosswordGrid}>
        {grid.map((row, y) =>
          row.map((cell, x) => {
            const isActive = cell.trim() !== "";
            const key = `${x},${y}`;

            if (!isActive) return <div key={key} css={emptyCellBase} />;

            const hint = hintLetters[key];
            const isHintCell = isStudent && !!hint;
            const cellNumber = positionToNumber.get(key);
            const value = isStudent
              ? (studentAnswers[key] ?? "")
              : (hintLetters[key] ?? "");

            return (
              <div key={key} css={gridCellBase}>
                {cellNumber && <span css={getCellNumber}>{cellNumber}</span>}
                {isHintCell ? (
                  <span
                    css={getCellHint}
                    aria-label={`Cell row ${y + 1} column ${x + 1}`}
                    data-qa-selector={`crossword-cell-${x}-${y}`}
                  >
                    {hint}
                  </span>
                ) : (
                  <input
                    css={getCellInput}
                    type="text"
                    maxLength={1}
                    value={value}
                    onChange={(e) => onCellChange(x, y, e.target.value)}
                    aria-label={`Cell row ${y + 1} column ${x + 1}`}
                    data-qa-selector={`crossword-cell-${x}-${y}`}
                  />
                )}
              </div>
            );
          }),
        )}
      </div>
    </div>
  );
};

export default CrosswordGrid;
